// Equalise the heights of a selection of elements (on page load)
var equaliseResize;
var equalise = new EqualiseHeight($('.js-equalise-height'));

equalise.init();
equalise.update();

// Equalise the heights of a selection of elements (on window resize)
$(window).on('resize', function() {
    clearTimeout(equaliseResize);
    equaliseResize = setTimeout(function() {
        equalise.update();
    }, 100);
});

function EqualiseHeight(el) {

    // Variables
    var className = 'equalise-height';
    var target = '__target';
    var targets = [];
    var breakpoint = 750;

    // Public functions
    this.init = init;
    this.update = update;
    this.reset = reset;

    // Functions

    // Configure the groups
    function init() {

        el.find('.js-' + className + target).addClass(className).each(function() {
            var group = $(this).data(className + '--group');
            if (targets.indexOf(group) == -1) {
                targets.push(group);
            }
        });
    }

    // Equalise all elements
    function equalise() {
        for (var i = 0; i < targets.length; i++) {
            (function(i) {
                var max = 0;
                el.find('.js-' + className + target + '[data-' + className + '--group="' + targets[i] + '"]').addClass(className + target).each(function() {
                    if ($(this).height() > max) {
                        max = $(this).height();
                    }
                });
                el.find('.js-' + className + target + '[data-' + className + '--group="' + targets[i] + '"]').addClass(className + target).each(function() {
                    var align = $(this).data(className + '--align');
                    var padding = (max - $(this).height()) / 2;

                    var css;
                    // Top default
                    if (!align || align == 'top') {
                        css = {
                            paddingBottom: 2 * padding
                        };
                    } else if (align == 'middle') {
                        css = {
                            paddingTop: padding,
                            paddingBottom: padding
                        };
                    } else if (align == 'bottom') {
                        css = {
                            paddingTop: 2 * padding
                        };
                    }

                    $(this).css(css);
                });
            })(i);
        }
    }

    // Reset all elements
    function reset() {
        for (var i = 0; i < targets.length; i++) {
            (function(i) {
                el.find('.js-' + className + target + '[data-' + className + '--group="' + targets[i] + '"]').removeClass(className + target).attr('style', '');
            })(i);
        }
    }

    // Update the elements
    function update(desktopOnly) {
        reset();
        if (desktopOnly && window.matchMedia('(max-width : ' + breakpoint + 'px)').matches) {
            return;
        }
        equalise();
    }
}
